import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import authenticationSlice from './authenticationSlice';
import onboardingSlice from './onboardingSlice';
import importEmployeesSlice from './importEmployeesSlice';
import phoneVerificationSlice from './phoneVerificationSlice';
import rewardFlowSlice from './rewardFlowSlice';

import { AuthenticationSlice } from './authenticationSlice/types';
import { OnboardingSlice } from './onboardingSlice/types';
import { ImportEmployeesSlice } from './importEmployeesSlice/types';
import { PhoneVerificationSlice } from './phoneVerificationSlice/types';
import { RewardFlowSlice } from './rewardFlowSlice/types';

export const useImportEmployeesStore = create<ImportEmployeesSlice>()(
  devtools(
    persist(
      (set, get, api) => ({
        ...importEmployeesSlice(set, get, api),
      }),
      { name: 'import-employees' }
    )
  )
);

export const useAuthenticationStore = create<AuthenticationSlice>()(
  devtools((set, get, api) => ({
    ...authenticationSlice(set, get, api),
  }))
);

export const useOnboardingStore = create<OnboardingSlice>()(
  devtools((set, get, api) => ({
    ...onboardingSlice(set, get, api),
  }))
);

export const usePhoneVerificationStore = create<PhoneVerificationSlice>()(
  devtools((set, get, api) => ({
    ...phoneVerificationSlice(set, get, api),
  }))
);

export const useRewardFlowStore = create<RewardFlowSlice>()(
  devtools((set, get, api) => ({
    ...rewardFlowSlice(set, get, api),
  }))
);
